// @flow
const defaultGeolocationWatchPositionOptions = {
    enableHighAccuracy: true,
    maximumAge: 1000,
    timeout: 3000
};

export const registerGeolocationWatchPosition = (success: (coords: Coordinates) => void,
                                                 error: (err: any) => void,
                                                 options?: Object = {}) => {
    if (!navigator.geolocation) {
        return;
    }
    const geolocation = navigator.geolocation;
    geolocation.watchPosition(
        (position) => success(position.coords),
        (err) => error(err),
        {
            ...defaultGeolocationWatchPositionOptions,
            ...options,
        });
};


// WEBPACK FOOTER //
// ./src/Utils/LocationUtils.js